exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".squarePicture .el-image__inner {\n  -o-object-position: center center;\n     object-position: center center;\n}\n.verticalPicture .el-image__inner {\n  -o-object-position: center top;\n     object-position: center top;\n}\n.horizontalPicture .el-image__inner {\n  -o-object-position: center center;\n     object-position: center center;\n}\n", ""]);

// exports
